import * as React from 'react';

interface Props {
	isCopying: boolean;
	copyFinished: boolean;
}

const CopyProgressBar: React.FC<Props> = (props) => {
	const { isCopying, copyFinished } = props;

	const copyProgress = copyFinished ? '--finished' : '--in-progress';
	return (
		<div className={`copy-container ${(isCopying && !copyFinished) || (!isCopying && copyFinished) ? `--visible ${copyProgress}` : '--hidden'}`}>
			<div className="copy-progress-bar" />
			<span className="copy-label" />
		</div>
	);
};

export default React.memo(CopyProgressBar);
